
export function painel(conteudo, config, configTable) {
    let rows = [];
    let defaultConfig = {
        style: 'tableExample',
        margin: [0, 0, 0, 1],
        layout: 'noBorders'
    };
    if (Array.isArray(conteudo)) {
        if (Array.isArray(conteudo[0])) {
            rows = conteudo;
        } else {
            rows.push(conteudo);
        }
    } else {
        defaultConfig = { ...defaultConfig, widths: ['*'] }
        rows.push([conteudo])
    }


    if (config) {
        defaultConfig = { ...defaultConfig, ...config }
    }

    return {
        // margin: defaultConfig.margin,
        // style: defaultConfig.style,
        table: {
            body: rows,
            widths: defaultConfig.widths,
            ...configTable
        },
        // layout: defaultConfig.layout,
        ...defaultConfig
    }
}